import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Icon, Table } from 'antd'
import _ from 'lodash'

import * as actions from './UserManagementPageActions'
import IrreversibleButton from '../Commons/IrreversibleButton/IrreversibleButton'
import UserManagementModal from '../Commons/UserManagementModal/UserManagementModal'
import './UserManagementPage.scss'

export class UserManagementPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedRowKeys: [],
            modalVisible: false,
            selectedUserId: ''
        }
    }

    handleModalOpen(userId) {
        this.setState({ modalVisible: true, selectedUserId: userId })
    }

    handleUserRemove() {
        const { removeUsers, token } = this.props
        const { selectedRowKeys } = this.state
        removeUsers(token, selectedRowKeys)
    }

    componentDidMount() {
        const { fetchUserList, token } = this.props
        fetchUserList(token)
    }

    render() {
        const { token, userList, fetchUser, addUser, updateUser } = this.props
        const { selectedRowKeys, modalVisible, selectedUserId } = this.state

        const columns = [{
            title: 'Username',
            dataIndex: 'username',
            sorter: (a, b) => a.username.localeCompare(b.username),
        }, {
            title: 'User Type',
            dataIndex: 'user_type',
            render: (text, row) => _.startCase(text),
            sorter: (a, b) => a.user_type.localeCompare(b.user_type),
        }, {
            title: 'First Name',
            dataIndex: 'first_name',
            sorter: (a, b) => a.first_name.localeCompare(b.first_name),
        }, {
            title: 'Last Name',
            dataIndex: 'last_name',
            sorter: (a, b) => a.last_name.localeCompare(b.last_name),
        }, {
            title: 'Email',
            dataIndex: 'email',
            sorter: (a, b) => a.email.localeCompare(b.email),
        }]

        return (
            <div className="UserManagementPage">
                <div className="table-btn-gp">
                    <div className="table-btn-gp-left">
                        <button onClick={(e) => this.handleModalOpen()}>
                            <Icon type="plus"/>
                            Create
                        </button>
                    </div>
                    <div className="table-btn-gp-right">
                    	<IrreversibleButton 
                    		onConfirm={(e) => this.handleUserRemove()} 
                    		btnText={<div><Icon type="minus"/>Remove</div>}
                    		disabled={selectedRowKeys.length === 0}
                    	/>
                    </div>
                </div>
                <UserManagementModal
                	token={token}
                	selectedUserId={selectedUserId}
                	visible={modalVisible}
                	onCancel={() => this.setState({ modalVisible: false })}
                	fetchUser={(token, userId, cb) => fetchUser(token, userId, cb)}
                	addUser={(token, userInfo, cb) => addUser(token, userInfo, cb)}
                	updateUser={(token, userId, userInfo, cb) => updateUser(token, userId, userInfo, cb)}
                />
                <Table
                    rowSelection={{selectedRowKeys, onChange: (selectedRowKeys) => this.setState({selectedRowKeys})}} 
                    columns={columns} 
                    rowKey={'_id'}
                    dataSource={userList} 
                    onRowClick={(record, index) => this.handleModalOpen(record._id)}
                />
			</div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        userList: state.userManagementPage.userList
    }
}

export default connect(mapStateToProps, actions)(UserManagementPage)


// WEBPACK FOOTER //
// ./src/UserManagementPage/UserManagementPage.js